<script setup lang="ts">
    import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
    import { useInitials } from '@/composables/useInitials';
    import type { User } from '@/types';
    import { computed } from 'vue';

    defineProps<{
        progress: number;
    }>();
</script>

<template>
    <div
        class="border-primary/50 flex h-5 w-32 items-center justify-center rounded-xs border"
        :style="{ 'background-color': `rgba(55, 166, 225, ${progress}%)` }"
    >
        <span
            class="text-xs"
            :class="progress > 50 ? 'text-white' : 'text-foreground'"
            >{{ progress }}%</span
        >
    </div>
</template>
